import React, { createContext, useState } from "react";

const GerenciamentoContratoFilterContext = createContext();

const GerenciamentoContratoFilterContextProvider = ({ children }) => {
  const [filtersStorage, setFiltersStorage] = useState(null);
  const [listBillingRules, setListBillingRules] = useState([]);

  return (
    <GerenciamentoContratoFilterContext.Provider
      value={{
        filtersStorage,
        setFiltersStorage,
        listBillingRules,
        setListBillingRules,
      }}
    >
      {children}
    </GerenciamentoContratoFilterContext.Provider>
  );
};

export {
  GerenciamentoContratoFilterContext,
  GerenciamentoContratoFilterContextProvider,
};
